import { render, staticRenderFns } from "./OverlayAd.vue?vue&type=template&id=653963d5&scoped=true"
import script from "./OverlayAd.vue?vue&type=script&lang=js"
export * from "./OverlayAd.vue?vue&type=script&lang=js"
import style0 from "./OverlayAd.vue?vue&type=style&index=0&id=653963d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653963d5",
  null
  
)

export default component.exports